/**
 * 缓存显示校准：与 Vue、DOM、网络无关，移动端可使用同一状态机。
 * show 只接受隐藏->显示或身份变化；普通重绘/弹窗关闭不能新开一轮。
 * 每轮每区域最多尝试一次（失败也计入）；普通加载成功用 markFresh 排除重复请求。
 * hide 使在途票据失效；网络取消由调用方决定，旧响应绝不能落入下一轮。
 */
export function createVisibleRegionRefresh() {
  let visible = false, scope = '', round = 0, flight = null
  let attempted = new Set()
  const current = ticket => !!ticket && visible && ticket.round === round && ticket.scope === scope
  return {
    show(nextScope) {
      if (visible && scope === nextScope) return false
      visible = true; scope = nextScope; round++; attempted = new Set(); flight = null
      return true
    },
    hide() { visible = false; round++; flight = null },
    snapshot() { return { round, scope } },
    isCurrent: current,
    markFresh(ids, ticket) {
      if (ticket && !current(ticket)) return
      if (visible) (ids || []).forEach(id => attempted.add(String(id)))
    },
    take(ids, limit = 3) {
      if (!visible || flight) return null
      const selected = [...new Set((ids || []).map(String))].filter(id => id && !attempted.has(id)).slice(0, limit)
      if (!selected.length) return null
      selected.forEach(id => attempted.add(id))
      flight = { round, scope, ids: selected }
      return flight
    },
    finish(ticket) { if (flight === ticket) flight = null }
  }
}

// Query snapshots must not overwrite a device changed by a control/push after the request began.
// Preserve the entire newer row (including product-specific fields), not just openState.
export function mergeRegionSnapshot(incoming, before, current, key) {
  const previous = new Map(before.map(row => [key(row), JSON.stringify(row)]))
  const latest = new Map(current.map(row => [key(row), row]))
  const changed = id => latest.has(id) && JSON.stringify(latest.get(id)) !== previous.get(id)
  // Retained rows precede server rows. When a device moved from an offscreen region,
  // the authoritative incoming row replaces its old identity instead of duplicating a card.
  const result = [...new Map(incoming.map(row => [key(row), changed(key(row)) ? latest.get(key(row)) : row])).values()]
  const returned = new Set(result.map(key))
  current.forEach(row => { if (!returned.has(key(row)) && changed(key(row))) result.push(row) })
  return result
}
